export class TemplateRenderError extends Error {
  constructor(error: Error) {
    super(error.message);
    Object.setPrototypeOf(this, TemplateRenderError.prototype);
    this.stack = error.stack;
    this.name = error.name;
  }
}
